import TypographyMontserrat from "../../Atoms/TypographyMontserrat";
import React from "react";
import QuickAddToCart from "../AddToCart/QuickAddToCart";
import LowStockIndicator from "../LowStockIndicator";
import clsx from "clsx";
import {
    sortByVariantSize,
    transformProducts,
    formatPrice,
} from "../../utils/utils";
import { Heading } from "@/components/Atoms/TypographyPoppins";
import TypographyPoppins from "@/components/Atoms/TypographyPoppins";
import Image from "next/image";
import { FilledHeart, EmptyHeart } from "@/public/Theme";

import { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import ProductCarousel from "../ProductCarousel";

const Portal = ({ children }) => {
    const [mounted, setMounted] = useState(false);

    useEffect(() => setMounted(true), []);

    if (!mounted) return null;

    return ReactDOM.createPortal(children, document.body);
};

const QuickAddToCartPopup = ({
    setShowVariants,
    productName,
    currencyCode,
    price,
    sizeStandard,
    selectedVariant,
    setSelectedVariant,
    variants,
    imagesCollection,
    brandName,
    salesPrice,
    isWishListItem,
    addProductToWishList,
    removeProductToWishList,
    showCarousel,
    totalStockOfVariants,
}) => {
    // variants = transformProducts(variants);
    const sortedVariants = sortByVariantSize(variants);
    return (
        <Portal>
            {/* Wrapper div with position fixed and high z-index */}
            <div className="fixed inset-0 z-[201] sm:hidden">
                {/* Backdrop behind modal content */}
                <div
                    className="absolute inset-0 bg-black opacity-35"
                    onClick={() => setShowVariants(false)}
                />

                {/* Modal content in front of backdrop */}
                <div className="absolute bottom-0 w-full bg-white h-max px-5 py-6 rounded-t-lg">
                    <div
                        className={`grid ${showCarousel ? "grid-cols-1 gap-x-4" : "grid-cols-2"} md:grid-cols-2 md:gap-x-8`}
                    >
                        <ProductCarousel
                        isMobile={true}
                            imagesCollection={imagesCollection}
                            productName={productName}
                            showCarousel={showCarousel}
                        />
                        <div className="pt-5">
                            <div className="flex items-center justify-between">
                                <Heading
                                    decoration={"underline"}
                                    fontWeight={"bold"}
                                    customStyle={"text-sm sm:text-base"}
                                    text={brandName}
                                    color={"New_Primary_Default"}
                                />
                                <div>
                                    {!isWishListItem ? (
                                        <Image
                                            onClick={addProductToWishList}
                                            src={EmptyHeart}
                                            width={24}
                                            height={24}
                                            alt="filled-heart"
                                        />
                                    ) : (
                                        <Image
                                            onClick={removeProductToWishList}
                                            src={FilledHeart}
                                            width={24}
                                            height={24}
                                            alt="filled-heart"
                                        />
                                    )}
                                </div>
                            </div>

                            <TypographyPoppins
                                align="left"
                                customStyle="!text-base"
                                fontWeight="light"
                                text={productName}
                            />
                            <div className="flex items-center">
                                {salesPrice && (
                                    <TypographyPoppins
                                        align="left"
                                        color={"danger"}
                                        customStyle="text-xs sm:text-sm mr-3"
                                        fontWeight="normal"
                                        text={salesPrice}
                                    />
                                )}
                                {price && (
                                    <TypographyPoppins
                                        align="left"
                                        customStyle={`text-xs sm:text-sm ${
                                            salesPrice && "line-through"
                                        }`}
                                        fontWeight="normal"
                                        text={formatPrice(price, currencyCode)}
                                    />
                                )}
                            </div>

                            <LowStockIndicator
                                remainingStock={
                                    selectedVariant?.stock ||
                                    selectedVariant?.inventory_level
                                }
                            />
                        </div>
                    </div>

                    <div className="flex mt-5 gap-x-3 mb-3">
                        <TypographyPoppins
                            align="left"
                            customStyle="!text-sm"
                            fontWeight="normal"
                            text={"Size: " + sizeStandard}
                        />
                    </div>

                    <div className="flex flex-wrap gap-x-2 items-center mb-6">
                        {sortedVariants?.map((variant, index) => {
                            const sizeOption = variant?.option_values?.find(
                                (option) =>
                                    option?.option_display_name === "Size"
                            );
                            const selected =
                                selectedVariant?.id === variant?.id;
                            const isAvailableForSale =
                                variant?.inventory_level > 0;

                            return (
                                <div
                                    key={index}
                                    className={clsx(
                                        "relative flex cursor-pointer font-Poppins justify-center items-center w-10 h-10 border leading-[180%] border-0 text-xs !bg-Ghost_White h-[44px] w-[44px] ",
                                        {
                                            "!bg-selected_pink text-Pink_Rose":
                                                selected && isAvailableForSale,
                                            "ring-1 ring-transparent transition duration-300 ease-in-out ":
                                                !selected && isAvailableForSale,
                                            "cursor-not-allowed overflow-hidden pointer-events-none bg-neutral-100 text-neutral-500 ring-0 ring-neutral-300  before:bg-neutral-300":
                                                !isAvailableForSale,
                                        }
                                    )}
                                    onClick={() =>
                                        isAvailableForSale &&
                                        setSelectedVariant(variant)
                                    }
                                >
                                    {sizeOption?.label}
                                </div>
                            );
                        })}
                    </div>

                    <QuickAddToCart
                        quantity={1}
                        selectedVariantData={selectedVariant}
                        availableForSale={true}
                        productName={productName}
                    />
                </div>
            </div>
        </Portal>
    );
};

export default QuickAddToCartPopup;
